import React from 'react';
import {ExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons';
import {useControllerProps} from '../../domain/controllers/ControllerContext';

export const ExpressButtons = ({dataHook}: {dataHook: string}) => {
  const {dynamicPaymentOptionsProps} = useControllerProps().cashierExpressStore;
  const {estimatedTotals, cartModel, sendCurrencyToExpressWidget, fixExpressWrongTotalAmount} =
    useControllerProps().cartStore;

  const shouldRequestShipping = dynamicPaymentOptionsProps?.shouldRequestShipping;
  const canCheckout = dynamicPaymentOptionsProps?.canCheckout;

  let currency: string | undefined;
  if (sendCurrencyToExpressWidget) {
    currency = fixExpressWrongTotalAmount ? estimatedTotals.paymentCurrencyCode : cartModel.paymentCurrencyCode;
  }

  return (
    <ExpressCheckoutButtons
      layout={'vertical'}
      currency={currency}
      isShippable={shouldRequestShipping}
      estimatedTotal={estimatedTotals?.estimatedAmountToPay.toString()}
      canStartPayment={canCheckout}
      theme={dynamicPaymentOptionsProps?.getButtonTheme}
      buttonStyle={dynamicPaymentOptionsProps?.buttonStyle}
      dataHook={dataHook}
    />
  );
};
